import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Category } from '../../../../models/category';
import { Observable, Subscription } from 'rxjs';
import { IProductByCategoryResponse, IReassingCategories } from '../../../../models/Interfaces';


@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private _http: HttpClient) { }

  list(
    storeId: string,
    pageNumber?: number,
    pageSize?: number,
    name?: string,
    root?: boolean,
    categoryType: string = 'DEFAULT'  
  ) {
    if (!pageNumber) { pageNumber = 1; }
    if (!pageSize) { pageSize = 10; }
    if (!name) { name = ""; }
  
    return this._http.get(
      `${environment.url}/management/category/store/${storeId}?pageNumber=${pageNumber}&pageSize=${pageSize}&name=${name}&categoryType=${categoryType}&root=${root ? root : false}`
    );
  }
  

  listProductsByCategory(
    storeId: string,
    pageNumber: number = 1,
    pageSize: number = 10,
    categoryId: string = '',
    searchType?: string,
    data?: { name?: string; sku?: string }
  ): Observable<any> {
    const params: any = {
      pageNumber,
      pageSize
    };
  
    if (searchType === 'Nombre' && data?.name) {
      params.name = data.name;
    } else if (searchType === 'SKU' && data?.sku) {
      params.sku = data.sku;
    }
  
    const url = `${environment.url}/management/category/store/${storeId}/category/${categoryId || ''}/products-by-category`;
  
    return this._http.get(url, { params });
  }
  
  
  getSubcategories(storeId: string, parentId: string) {
    return this._http.get(environment.url + `/management/category/store/${storeId}/category/${parentId}`);
  }
  
  get(storeId: string, id: string) {
    return this._http.get(environment.url + `/management/category/store/${storeId}/${id}`);
  }
  
  delete(storeId: string, id: string) {
    return this._http.delete(environment.url + `/management/category/store/${storeId}/${id}`);
  }
  
  update(category: Category) {
    return this._http.put(environment.url + `/management/category/store/${category.storeId}`, category);
  }

  reassingCategory(categories: IReassingCategories[], storeId: string, productId: string){
    return this._http.put(environment.url + `/management/category/store/${storeId}/product/${productId}/reassign-categories`, categories);
  }
  
  create(category: Category) {
    return this._http.post(environment.url + `/management/category/store/${category.storeId}`, category);
  }

  upload(storeId: string, file: FormData) {
    return this._http.post(environment.url + `/management/category/store/${storeId}/upload`, file);
  }

  downloadExportFileDataCategory(storeId: string): Observable<Blob> {
    const url = `${environment.url}/management/category/store/${storeId}/export/file-data`;
    return this._http.get(url, { responseType: 'blob' });
  }
  
}
